import { Grid } from "@mui/material";
import React from "react";
import InputGroupShape from "../../../../../../../../components/Inputs/InputGroupShape";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { lightTable } from "../../../../../../../../styles/muiProps";

export default function ShellPanel() {
  const table = useMaterialReactTable({
    ...lightTable,
    data: [
      { component: "2:1 S.E Head (L/B)" },
      { component: "Cylindrical Shell" },
      { component: "Cylindrical Shell" },
      { component: "2:1 S.E Head" },
    ],
    columns: [
      {
        accessorKey: "component",
        header: "Component",
        size: 60,
      },
      {
        accessorKey: "dia",
        header: "Inside Diameter (in)",
        size: 60,
      },
      {
        accessorKey: "material",
        header: "Material",
        size: 60,
      },
      {
        accessorKey: "canLength",
        header: "Can Length (in)",
        size: 60,
      },
      {
        accessorKey: "seamANgle",
        header: "Long Seam Angle (Deg)",
        size: 60,
      },
      {
        accessorKey: "thn",
        header: "Provided Thk (in)",
        size: 60,
      },
    ],
  });
  return (
    <Grid container>
      <Grid item xs={8} sx={{ pt: 2 }}>
        <InputGroupShape name="Shell Data">
          <MaterialReactTable table={table} />
        </InputGroupShape>
      </Grid>
    </Grid>
  );
}
